import { PURCHASER_API_BASE_URL, getHeaders } from "../Constants";
import type { UserEmailSenderSignature } from "./RFQ.ts";

export default {
    createConnectedEmail: (account: string) =>
        fetch(`${PURCHASER_API_BASE_URL}/connect-email/senders/${account}`, {
            headers: getHeaders(),
            method: "POST",
            body: JSON.stringify({}),
        }).then(async res => {
            if (!res.ok) {
                // If we have a sender with the same email, we get back a 409
                // conflict error code as this means the user tried to connect the
                // same email multiple times for the same team. We also get the
                // existing account information so we can catch this error but still
                // route the user back to the RFQ with the existing connected email
                // appropriately.
                if (res.status === 409) {
                    const bodyJSON = await res.json();
                    return bodyJSON.sender;
                }

                throw new Error("Failed to create connected email");
            }
            return res.json();
        }),

    fetchConnectedEmail: (account: string) =>
        fetch(`${PURCHASER_API_BASE_URL}/connect-email/senders/${account}`, {
            headers: getHeaders(),
            method: "GET",
        }).then(res => res.json()),

    fetchConnectedEmails: () =>
        fetch(`${PURCHASER_API_BASE_URL}/connect-email/senders`, {
            headers: getHeaders(),
            method: "GET",
        }).then(res => res.json()),

    getConnectEmailUrl: () =>
        fetch(`${PURCHASER_API_BASE_URL}/connect-email/get-url`, {
            headers: getHeaders(),
            method: "POST",
            body: JSON.stringify({}),
        }).then(res => res.json()),

    deleteConnectedEmail: (account: string) =>
        fetch(`${PURCHASER_API_BASE_URL}/connect-email/senders/${account}`, {
            headers: getHeaders(),
            method: "DELETE",
            body: JSON.stringify({}),
        }).then(res => {
            if (!res.ok) {
                throw new Error("Error disconnecting email");
            }
            return res.json();
        }),

    fetchConnectedEmailsSignatures: (): Promise<UserEmailSenderSignature[]> =>
        fetch(`${PURCHASER_API_BASE_URL}/connect-email/senders/signatures`, {
            headers: getHeaders(),
            method: "GET",
        }).then(async res => {
            if (!res.ok) {
                return [];
            }
            const json = await res.json();
            return json as UserEmailSenderSignature[];
        }),
};
